/**
 * Global auth middleware. On any route that isn't /auth/*, if no token is present,
 * redirect to the auth app (auth.privacybee.com OAuth) preserving the buyer's plan
 * selection via the OAuth `state` param.
 */
import { oauthAuthorizeUrl } from '~/utils/auth-redirect';

export default defineNuxtRouteMiddleware((to) => {
    if (import.meta.server) return;
    if (to.path.startsWith('/auth/')) return;
    if (to.meta.public === true) return;

    const config = useRuntimeConfig();
    const auth = useAuthStore();

    if (auth.token) return;

    // CSRF (RFC 6749 §10.12): the URL carries a random per-login nonce in `state` and stores it
    // for this tab; the callback rejects the code exchange unless the returned nonce matches.
    const authUrl = oauthAuthorizeUrl(config.public.pb, {
        plan: to.query.plan ?? null,
        term: to.query.term ?? null,
        path: to.fullPath,
    });
    return navigateTo(authUrl, { external: true });
});
